<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 50.667 77">
        <g id="Group_2885" data-name="Group 2885" transform="translate(-1268.334 -1221)">
            <g id="pin" transform="translate(1183.001 1221)">
                <g id="Group_2883" data-name="Group 2883" transform="translate(85.333)">
                    <path id="Path_70175" data-name="Path 70175"
                          d="M110.666,0A25.336,25.336,0,0,0,88.374,37.372l20.907,38.811a1.584,1.584,0,0,0,2.771,0L132.966,37.36A25.338,25.338,0,0,0,110.666,0Z"
                          transform="translate(-85.333)" fill="#3266f5"/>
                </g>
            </g>
            <circle id="Ellipse_210" data-name="Ellipse 210" cx="20" cy="20" r="20" transform="translate(1274 1226)"
                    fill="#799cfb" opacity="0.4"/>
            <g id="doctor" transform="translate(1262.243 1232.199)">
                <path id="Path_70159" data-name="Path 70159"
                      d="M22.256,5.2h1.582a2.6,2.6,0,1,0-2.6-2.6V3.747A5.047,5.047,0,0,0,18,8.622c.037,4.3,4.458,9.7,8.441,10.432V21.8a7.805,7.805,0,1,0,15.611,0V20.785a4.336,4.336,0,1,0-1.734,0V21.8a6.071,6.071,0,0,1-12.142,0v-2.74c3.721-.675,7.666-5.34,8.33-9.27a5.2,5.2,0,0,0-3.127-6.028V2.6a2.6,2.6,0,1,0-2.6,2.6h1.557A3.516,3.516,0,0,1,34.794,9.5c-.654,3.869-4.809,7.905-7.487,7.905-3.1,0-7.542-5.027-7.574-8.8A3.413,3.413,0,0,1,22.256,5.2Zm.715-2.6a.867.867,0,1,1,.867.867H22.97Zm8.673.867h-.867a.867.867,0,1,1,.867-.867Z"
                      transform="translate(0)" fill="#fff"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "IPractitionerPin",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
